export const listTableOption = {
  // 帖子列表信息
  page:false,
  border: true,
  stripe: true,
  align:'center',
  menuAlign:'center',
  refreshBtn: false,
  delBtn: false,
  editBtn: false,
  addBtn: false,
  searchShow: false,
  searchBtn: false,
  column: [{
    label: 'ID',
    prop: 'id',
    width: 120,
  },{
    label: '内容预览',
    width: 260,
    prop: 'title',
    overHidden: true,
    solt: true,
    align: 'left'
  },{
    label: '所属圈子',
    prop: 'circleName',
    align: 'left',
    overHidden: true,
    width: 120,
  }, {
    label: '发布者昵称',
    width: 160,
    prop: 'postedByName',
    overHidden: true,
    align: 'left'
  }, {
    label: '发布者姓名',
    width: 160,
    prop: 'postedByRealname',
    overHidden: true,
    align: 'left'
  }, {
    label: '内容类别',
    width: 80,
    prop: 'postType',
    align: 'left',
  }, {
    label: '评论量',
    prop: 'commentCount',
    sortable: true,
    align: 'left',
    width: 100,
  }, {
    label: '点赞量',
    prop: 'likeCount',
    sortable: true,
    align: 'left',
    width: 100,
  }, {
    label: '收藏量',
    prop: 'favoriteCount',
    sortable: true,
    align: 'left',
    width: 100,
  }, {
    label: '浏览量',
    prop: 'viewedCount',
    sortable: true,
    hide: true,
    align: 'left',
    width: 100,
  }, {
    label: '发布时间',
    prop: 'postTime',
    sortable: true,
    align: 'left',
    width: 160,
  }, {
    label: '初始热度值',
    prop: 'manualHeatValue',
    sortable: true,
    align: 'left',
    width: 120,
  }, {
    label: '热度值',
    prop: 'finalHeatValue',
    sortable: true,
    align: 'left',
    width: 110,
  }, {
    label: '是否已下架',
    prop: 'isNotBanned',
    align: 'left',
    width: 110,
  },{
    label: '下架原因',
    prop: 'banComment',
    overHidden: true,
    hide: true,
    align: 'left',
    width: 160,
  }]
}
